const datePickerStyles = {
  "& .MuiInputBase-root": {
    maxHeight: "24px",
    minWidth: 220,
    fontSize: "10px",
    padding: "5px 10px",
    borderRadius: "4px",
    backgroundColor: "white",

    "& input": {
      padding: "0",
    },

    "& .MuiSvgIcon-root": {
      fontSize: "16px",
    },
  },
};

const datePickerSlotProps = {
  layout: {
    sx: {
      "& .MuiPickersSlideTransition-root": {
        minHeight: "192px",
        maxHeight: "200px",
      },
    },
  },
  popper: {
    sx: {
      "& .MuiPaper-root": {
        borderRadius: "16px",
        maxHeight: "300px",
      },
    },
  },
  yearButton: {
    sx: {
      fontSize: "12px",
    },
  },
  calendarHeader: {
    sx: {
      padding: "8px 16px !important",
      margin: "0px",
      marginLeft: "16px !important",
      "& .MuiPickersCalendarHeader-label": {
        fontSize: "12px",
      },
    },
  },
};

export { datePickerStyles, datePickerSlotProps };